import type { Article } from '@/types';

export const articles: Article[] = [
  {
    id: 'a-1001',
    title: '某慢综录制现场的真实节奏：一天拍满 14 小时，正片只用 47 分钟',
    excerpt:
      '镜头里的悠闲午后，是录制现场连续两周高强度作业换来的。我们梳理了一档热门慢综艺的完整录制流程，看看「慢」是怎么被拍出来的。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20dark%20moody%20variety%20show%20recording%20stage%20with%20warm%20amber%20spotlights%20and%20silhouettes%20of%20cameras%2C%20soft%20film%20grain%2C%20editorial%20photography%2C%20rich%20shadows&width=800&height=600&seq=kg-variety-01&orientation=landscape',
    topicSlug: 'variety',
    topicName: '综艺现场',
    author: '看瓜爆料编辑部',
    date: '2026-09-08',
    dateLabel: '09 月 08 日',
    readTime: '6 分钟',
    heat: 18420,
    tags: ['慢综艺', '录制流程', '幕后'],
    isHot: true,
    quote: '一集 47 分钟的正片，对应的是一台摄像机连续开机 60 多个小时。',
    paragraphs: [
      '一档看起来最「佛系」的慢综艺，其实是所有综艺类型里单位时间素材量最大的。本期录制的场地在一处海拔 1200 米的山间民宿，六位常驻嘉宾、四组飞行嘉宾、二十余台机位，在两周内完成了全部录制。',
      '节目组的一天从清晨五点半开始。生活制片先到场确认早餐与拍摄分区，收音组在嘉宾起床前完成麦克风分发与三遍环境声采集。真正的「黄金录制时段」是上午九点到十一点，此时自然光最稳定，嘉宾状态也最好，导演组会把最重要的任务卡安排在这个窗口。',
      '外界最关心的「有没有剧本」，答案是：有流程，没有台词。节目组会给出当天的任务目标与可用的资源，但不规定嘉宾说什么。编剧组的工作是在拍摄结束后，从海量素材里挑出能串起情绪线的段落。',
      '剪辑阶段才是决定成片气质的关键。一集的拍摄素材通常在 30 到 50 小时之间，剪辑师要在其中找到三到五个情绪高点，再用环境镜头把节奏「放慢」。这也是慢综艺成片时长总是卡在 45 到 50 分钟的原因——再长，情绪曲线就撑不住了。',
      '至于嘉宾们的真实关系，录制两周确实会让一群人迅速熟络，但节目结束后能否维持联系，更多取决于后续是否有商务交集。这一点，行业里的人其实都心知肚明。',
    ],
  },
  {
    id: 'a-1002',
    title: '一部剧从拿到备案到定档，中间到底要过几道关',
    excerpt:
      '很多观众以为拍摄完成就离上线不远了，其实真正的长跑才刚开始。我们把一部剧从立项到播出的完整节点拆成了一份时间表。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20production%20control%20room%20with%20screens%20and%20timeline%20charts%2C%20moody%20warm%20red%20and%20green%20accents%2C%20editorial%20photography%2C%20soft%20film%20grain&width=800&height=600&seq=kg-filmtv-01&orientation=landscape',
    topicSlug: 'film-tv',
    topicName: '影视内幕',
    author: '沈知白',
    date: '2026-09-06',
    dateLabel: '09 月 06 日',
    readTime: '8 分钟',
    heat: 15360,
    tags: ['排播', '备案', '行业流程'],
    isHot: true,
    quote: '杀青只是中场休息，后期和审批才是真正消耗时间的部分。',
    paragraphs: [
      '一部 40 集的都市剧，从立项到上线平均需要 18 到 30 个月。其中拍摄只占 3 到 4 个月，剩下的时间全部消耗在后期、审批与排播协调上。',
      '第一个关键节点是备案公示。剧集需要在开拍前完成题材备案，拿到公示编号后才可以正式开机。这一步看似简单，但如果题材涉及特殊领域，前期沟通可能就要花掉两三个月。',
      '第二个节点是成片送审。剪辑完成后，制作方需要提交完整成片与技术审核材料。这一步的变量最大，修改意见往往不止一轮，所以成熟的制作方会在开机前就预留出剪辑调整的弹性空间。',
      '拿到发行许可后，就进入最微妙的排播阶段。平台会根据自己的年度内容计划、竞品排期甚至广告主需求来安排播出窗口。一部剧从「随时可播」到真正定档，等上三到六个月是非常常见的事。',
      '所以当你在热搜上看到「某剧官宣定档」时，那其实不是一条新闻的起点，而是一场长跑最后几百米的冲刺。',
    ],
  },
  {
    id: 'a-1003',
    title: '顶流工作室集体「收缩」：为什么今年大家都在减少公开行程',
    excerpt:
      '从机场路透到商业活动，头部艺人的公开露面肉眼可见地变少了。这不是巧合，而是一轮行业成本结构的调整。',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20airport%20corridor%20at%20night%20with%20warm%20amber%20light%20streaks%20and%20blurred%20figures%2C%20cinematic%20editorial%20photography%2C%20deep%20shadows%20and%20soft%20film%20grain&width=800&height=600&seq=kg-idol-01&orientation=landscape',
    topicSlug: 'idol-watch',
    topicName: '顶流追踪',
    author: '看瓜爆料编辑部',
    date: '2026-09-05',
    dateLabel: '09 月 05 日',
    readTime: '5 分钟',
    heat: 14080,
    tags: ['商务', '行程', '艺人管理'],
    paragraphs: [
      '细心的读者会发现，今年头部艺人的公开行程明显变「精」了：机场路透减少，商业站台合并，就连粉丝最期待的生图，也更多来自官方释出。',
      '原因之一是安保与场地成本的上涨。一场中等规模的线下活动，今年的综合成本比两年前高出约三成，而这些成本大多由品牌方承担，预算收紧后活动数量自然下降。',
      '原因之二是内容策略的调整。相比频繁露面，团队更愿意把资源集中在少数几个「重量级」项目上，通过稀缺性维持话题热度。少而精，反而更容易上热搜。',
      '对粉丝来说，这种变化最直接的影响是线下见面的机会变少。但从长远看，行程收敛也意味着艺人能把更多时间投入到作品本身，这未必是坏事。',
    ],
  },
  {
    id: 'a-1004',
    title: '数字专辑销量破百万之后，歌手真正到手的分成是怎么算的',
    excerpt:
      '一张销量亮眼的数字专辑，最终流向歌手口袋的比例可能远低于外界想象。我们来拆解一下这条分成链路。',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20music%20studio%20with%20vintage%20microphone%2C%20warm%20amber%20lamp%20glow%20and%20green%20accent%20light%2C%20cinematic%20editorial%20photography%2C%20soft%20film%20grain%20and%20deep%20shadows&width=800&height=600&seq=kg-music-01&orientation=landscape',
    topicSlug: 'music',
    topicName: '音乐动态',
    author: '陆行舟',
    date: '2026-09-03',
    dateLabel: '09 月 03 日',
    readTime: '7 分钟',
    heat: 11250,
    tags: ['分成', '数字专辑', '版权'],
    paragraphs: [
      '数字专辑的销售额看起来是一个整数，但真正进入分账环节时，会先被平台抽成、渠道成本、税费层层扣减，剩下的才是版权方收益。',
      '通常情况下，平台渠道的分成比例在二三成左右，具体取决于发行方与平台的合作协议。独家发行的作品，因为资源位更多，分成比例往往会谈得更细。',
      '版权方拿到的部分，还要在词曲作者、制作团队、歌手与公司之间分配。如果歌手本人不参与创作，那么他拿到的大头通常来自「演唱分成」这一项。',
      '这也是为什么越来越多歌手开始参与词曲创作与制作署名——那不只是艺术表达，也直接关系到收益结构。',
      '当然，对头部艺人来说，专辑本身更多是「内容资产」，真正的商业回报往往来自随之而来的巡演与代言。',
    ],
  },
  {
    id: 'a-1005',
    title: '一条红毯裙子的诞生：造型团队 21 天的博弈',
    excerpt:
      '红毯上的三分钟，背后是一个造型团队三周的方案推演。从借调到改款，每一步都是一场谈判。',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20moment%20with%20warm%20golden%20spotlights%20and%20flowing%20fabric%20silhouette%2C%20cinematic%20editorial%20photography%2C%20rich%20shadows%20and%20soft%20film%20grain&width=800&height=600&seq=kg-fashion-01&orientation=landscape',
    topicSlug: 'fashion',
    topicName: '时尚品牌',
    author: '苏舲',
    date: '2026-09-01',
    dateLabel: '09 月 01 日',
    readTime: '6 分钟',
    heat: 9860,
    tags: ['红毯', '造型', '高定'],
    paragraphs: [
      '一场大型活动的红毯造型，通常在三周前就进入筹备。第一步不是选衣服，而是确定「人设关键词」：这次要以什么形象出现，是清冷、明艳，还是松弛。',
      '确定关键词后，造型师会向多个品牌提交借调申请。高定礼服的档期极为紧张，同一个系列的样衣可能同时被三家团队申请，最终花落谁家，取决于艺人近期的商业热度与品牌关系的亲疏。',
      '拿到样衣只是开始。绝大多数礼服都需要根据艺人身材做微调，改动幅度从收腰线到重做肩部结构不等。这部分通常由品牌提供的工坊完成，周期约 5 到 7 天。',
      '真正的博弈发生在最后 48 小时：灯光测试、行走动线、配饰定档。任何一个环节出问题，都可能让整套方案推翻重来。',
      '当红毯照片冲上热搜的那一刻，造型团队的 21 天工作才算正式交卷，而他们往往已经开始了下一场的筹备。',
    ],
  },
  {
    id: 'a-1006',
    title: '对赌协议到期年，三家艺人工作室的账本逻辑',
    excerpt:
      '当艺人工作室的业绩承诺进入倒计时，内容策略会变得格外激进。这背后是一套清晰的商业计算。',
    cover:
      'https://readdy.ai/api/search-image?query=Dark%20modern%20office%20desk%20with%20financial%20charts%20and%20warm%20amber%20desk%20lamp%2C%20moody%20cinematic%20photography%2C%20soft%20film%20grain%20and%20deep%20shadows&width=800&height=600&seq=kg-capital-01&orientation=landscape',
    topicSlug: 'backstage',
    topicName: '幕后资本',
    author: '何砚',
    date: '2026-08-29',
    dateLabel: '08 月 29 日',
    readTime: '8 分钟',
    heat: 8730,
    tags: ['资本', '对赌', '工作室'],
    paragraphs: [
      '在娱乐行业，艺人工作室与资本方签订业绩承诺并不是新鲜事。承诺期内，工作室需要在约定年限内完成一定的营收目标，未达成往往需要以现金或股权补偿。',
      '因此，临近承诺期末尾的年份，工作室的内容与商务节奏会明显加快：接项目更积极，商务合作的门槛也更宽松。这是理性的商业选择，而非外界想象的「缺钱」。',
      '但加量并不总是等于优质。短期内密集上线作品，容易出现内容质量参差、口碑透支的情况，反而影响后续议价能力。',
      '成熟的团队会选择在承诺期后半段主动调整结构，把重心从「数量」转向「确定性高的重点项目」，用一到两部爆款来完成任务。',
      '说到底，对赌考验的不只是艺人的曝光能力，更是团队对项目的判断力与资源配置效率。',
    ],
  },
  {
    id: 'a-1007',
    title: '为什么大制作都爱挤暑期档：排片、宣发与回本周期',
    excerpt:
      '每年暑期都是大制作的必争之地，但挤进去未必是好事。我们算了一笔关于档期的账。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinema%20hall%20with%20rows%20of%20red%20seats%20and%20warm%20dim%20projector%20glow%2C%20cinematic%20editorial%20photography%2C%20soft%20film%20grain%20and%20deep%20shadows&width=800&height=600&seq=kg-filmtv-02&orientation=landscape',
    topicSlug: 'film-tv',
    topicName: '影视内幕',
    author: '沈知白',
    date: '2026-08-26',
    dateLabel: '08 月 26 日',
    readTime: '6 分钟',
    heat: 7640,
    tags: ['暑期档', '排片', '宣发'],
    paragraphs: [
      '暑期档之所以被争抢，核心原因是年轻观众的观剧时间集中。数据显示，暑期档的剧集完播率与讨论热度普遍高于其他档期约 20%。',
      '但档期红利并非均匀分配。同一时间窗口内，平台首页的推荐位有限，宣发预算也有限，排在前面的作品吃掉大部分流量，后面的作品很容易被淹没。',
      '因此成熟的排播策略会做「错位竞争」：要么抢在档期最开头，避开拥挤；要么选择一个相对冷门但受众精准的窗口。',
      '对制作方来说，真正的回本周期并不等于播出周期。广告招商、会员拉新、后续版权分销会持续影响收益，一部剧的完整商业回报往往要在上线半年后才能看清。',
    ],
  },
  {
    id: 'a-1008',
    title: '从超话数据到商务报价：品牌方到底看哪几个指标',
    excerpt:
      '粉丝数早已不是唯一的衡量标准。品牌在选择合作对象时，手里其实有一张更细的评分表。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20with%20warm%20red%20and%20amber%20glowing%20bars%20on%20dark%20background%2C%20cinematic%20editorial%20photography%2C%20soft%20film%20grain&width=800&height=600&seq=kg-idol-02&orientation=landscape',
    topicSlug: 'idol-watch',
    topicName: '顶流追踪',
    author: '看瓜爆料编辑部',
    date: '2026-08-23',
    dateLabel: '08 月 23 日',
    readTime: '5 分钟',
    heat: 6980,
    tags: ['商务', '数据', '品牌'],
    paragraphs: [
      '品牌在评估合作对象时，第一眼看的是「人群匹配度」，而非绝对声量。一位粉丝量中等但受众高度垂直的艺人，报价可能高过流量更大但人群分散的同行。',
      '第二看互动质量。评论区的讨论内容、转发链路的传播深度、粉丝的购买转化率，这些指标比单纯的点赞数更能说明问题。',
      '第三看风险系数。过往是否有负面舆情、合作品牌的续约率如何，都会进入评估模型。风险系数高的合作对象，即便数据亮眼，报价也会被压。',
      '这也解释了一个现象：有些艺人热搜不断，商务却始终不温不火；而有些低调的演员，代言却一个接一个。品牌投的是确定性，不是热闹。',
    ],
  },
  {
    id: 'a-1009',
    title: '综艺剪辑的隐藏规则：谁被保留，谁被一剪没',
    excerpt:
      '同样录制了十几个小时，有人成片镜头不到三分钟。剪辑台上，其实有一套不成文的取舍逻辑。',
    cover:
      'https://readdy.ai/api/search-image?query=Video%20editing%20timeline%20interface%20glowing%20in%20dark%20room%20with%20warm%20and%20green%20accents%2C%20cinematic%20editorial%20photography%2C%20soft%20film%20grain&width=800&height=600&seq=kg-variety-02&orientation=landscape',
    topicSlug: 'variety',
    topicName: '综艺现场',
    author: '林声',
    date: '2026-08-20',
    dateLabel: '08 月 20 日',
    readTime: '6 分钟',
    heat: 6210,
    tags: ['剪辑', '综艺', '镜头'],
    paragraphs: [
      '剪辑的第一原则是服务叙事。谁能让观众理解当期主题、谁推动了事件发展，谁就会被保留。这跟嘉宾的咖位关系没有外界想象的那么大。',
      '第二原则是情绪密度。一段素材即便信息量不大，只要能产生笑点或共情，剪辑师也会想办法留下来，甚至为此调整整期的结构。',
      '镜头偏少的常见原因有三种：当期主题与其人设不匹配、关键互动未能形成有效冲突、以及现场收音不理想。前两种靠剪辑无法补救，第三种则在后期有机会通过技术手段挽回一部分。',
      '所以「镜头少」往往不是被针对，而是素材与当期叙事不契合。理解了这一点，看综艺的视角会完全不一样。',
    ],
  },
  {
    id: 'a-1010',
    title: '音乐节为什么越来越像一场大型品牌快闪',
    excerpt:
      '舞台、灯光、周边，音乐节正在被重新定义为一种商业场景。这对乐迷意味着什么？',
    cover:
      'https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20stage%20at%20night%20with%20warm%20amber%20and%20green%20stage%20lights%20and%20crowd%20silhouettes%2C%20cinematic%20editorial%20photography%2C%20soft%20film%20grain&width=800&height=600&seq=kg-music-02&orientation=landscape',
    topicSlug: 'music',
    topicName: '音乐动态',
    author: '陆行舟',
    date: '2026-08-17',
    dateLabel: '08 月 17 日',
    readTime: '5 分钟',
    heat: 5640,
    tags: ['音乐节', '品牌', '现场'],
    paragraphs: [
      '近三年音乐节数量快速增长，但真正靠门票盈利的场次并不多。主办方的收入结构里，品牌赞助的占比越来越高。',
      '这直接影响了阵容编排：赞助商偏好的艺人与资深乐迷期待的阵容之间，需要反复平衡。因此你会看到同一场音乐节里，既有实验性很强的独立乐队，也有刚出道的流量新人。',
      '对乐迷来说，体验的变化也是真实的——周边、联名、打卡点变多了，纯粹的「听歌」时间被压缩。',
      '音乐节的商业化本身不是坏事，它让更多中小乐队有了演出机会。关键在于主办方是否愿意在商业与内容之间保留足够的诚意。',
    ],
  },
  {
    id: 'a-1011',
    title: '代言更替背后的时间线：品牌为什么偏爱新面孔',
    excerpt:
      '换代言人不只是「热度不够」这么简单。品牌方的每一次更替，背后都有一段完整的评估周期。',
    cover:
      'https://readdy.ai/api/search-image?query=Fashion%20editorial%20scene%20with%20warm%20golden%20light%20and%20elegant%20fabric%20texture%2C%20minimal%20dark%20backdrop%2C%20cinematic%20photography%20with%20soft%20film%20grain&width=800&height=600&seq=kg-fashion-02&orientation=landscape',
    topicSlug: 'fashion',
    topicName: '时尚品牌',
    author: '苏舲',
    date: '2026-08-14',
    dateLabel: '08 月 14 日',
    readTime: '5 分钟',
    heat: 5120,
    tags: ['代言', '品牌', '商务'],
    paragraphs: [
      '品牌更换代言人通常提前半年就开始评估。评估维度包括：艺人的公众形象稳定性、目标客群的偏好变化，以及竞品的签约动向。',
      '「偏爱新面孔」并不完全是审美问题。新人往往有更高的配合度与更低的合作成本，且更容易与品牌一起「讲故事」，形成新鲜的传播素材。',
      '但对品牌来说，新面孔也意味着风险：热度可能不稳定，粉丝转化需要时间验证。因此越来越多品牌采用「大使 + 代言人」的分层结构，用组合方式分散风险。',
      '对艺人团队而言，一份好的代言不只是曝光，更是长期形象资产的沉淀。签约前想清楚「这个品牌是否适合长期共存」，比短期的报价更重要。',
    ],
  },
  {
    id: 'a-1012',
    title: '短剧冲击下，传统影视公司的三条转型路径',
    excerpt:
      '短剧的崛起改变了内容生产的成本结构与观众习惯。传统团队正在用三种方式重新定位自己。',
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20content%20studio%20with%20vertical%20screens%20and%20warm%20amber%20lighting%20in%20dark%20room%2C%20cinematic%20editorial%20photography%2C%20soft%20film%20grain&width=800&height=600&seq=kg-capital-02&orientation=landscape',
    topicSlug: 'backstage',
    topicName: '幕后资本',
    author: '何砚',
    date: '2026-08-11',
    dateLabel: '08 月 11 日',
    readTime: '7 分钟',
    heat: 4780,
    tags: ['短剧', '转型', '行业'],
    paragraphs: [
      '第一条路径是「降维代理」：把长剧积累的制作能力封装成标准化的服务，为短剧团队提供选角、拍摄与后期支持，赚取确定性的服务费用。',
      '第二条路径是「精品竖屏」：主动进入短剧赛道，但用长剧的叙事标准去拍，用质量拉开与同行的差距。这条路成本更高，但更容易沉淀品牌。',
      '第三条路径是「IP 双向开发」：先用低成本短剧验证故事与受众，跑通后再开发成长剧或电影。这相当于把短剧变成了低风险的测试场。',
      '三条路各有取舍。前者稳但想象空间有限，后两者回报更高但需要团队真正理解新的内容节奏。目前行业里，同时押注多条路径的公司并不少见。',
    ],
  },
];

export const hotRank = [
  { id: 'a-1001', label: '某慢综录制现场实录：正片 47 分钟背后是 60 小时素材' },
  { id: 'a-1002', label: '一部剧从备案到定档，平均要花 18 到 30 个月' },
  { id: 'a-1003', label: '顶流工作室集体收缩：今年公开行程为什么变少' },
  { id: 'a-1004', label: '数字专辑破百万销量后，歌手到手分成怎么算' },
  { id: 'a-1006', label: '对赌到期年，艺人工作室的账本逻辑' },
  { id: 'a-1005', label: '一条红毯裙子的诞生：造型团队 21 天博弈' },
];

export const getArticleById = (id: string): Article | undefined =>
  articles.find((item) => item.id === id);

export const getArticlesByTopic = (slug: string): Article[] =>
  articles.filter((item) => item.topicSlug === slug);

export const getRelatedArticles = (article: Article, limit = 3): Article[] =>
  articles
    .filter((item) => item.id !== article.id && item.topicSlug === article.topicSlug)
    .slice(0, limit);